<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="mini" @click="goBack">返回</el-button>
      <span>对账单审批</span>
    </div>
    <!-- end of title -->

    <!-- start of form -->
    <div class="form-box" v-if="formData">
      <div id="printBill">
        <!-- start  对账单信息 -->
        <div style="position: relative" class="back-color-fff mt-4">
          <span class="form-title">对账单信息</span>
          <span class="form-title" v-if="formData.approveVO?.flowNo"
            >- {{ formData.approveVO.flowNo }}</span
          >
          <el-row :gutter="24">
            <el-col :span="8" class="base-box mt-10">
              <span class="label">申请人：</span>
              <div>{{ formData.applyStaffName || "-" }}</div>
            </el-col>
            <el-col :span="8" class="base-box mt-10">
              <span class="label">提交时间：</span>
              <div>{{ formData.settleDate | getDate }}</div>
            </el-col>
            <el-col :span="8" class="base-box mt-10">
              <span class="label">所在部门：</span>
              <div>{{ organisationName || "-" }}</div>
            </el-col>
            <el-col :span="8" class="base-box mt-10">
              <span class="label">上游服务商：</span>
              <div>{{ formData.serviceTenantName || "-" }}</div>
            </el-col>
            <el-col :span="8" class="base-box mt-10">
              <span class="label">对账日期：</span>
              <div>{{ formData.settleDate | getDate }}</div>
            </el-col>
            <el-col :span="8" class="base-box mt-10">
              <span class="label">申请盖章：</span>
              <div>{{ formData.isStampApply == "Y" ? "是" : "否" }}</div>
            </el-col>
            <el-col :span="8" class="base-box mt-10">
              <span class="label">核算月：</span>
              <div>{{ formData.accountMonth || "-" }}</div>
            </el-col>

            <el-col :span="8" class="base-box mt-10">
              <span class="label">账单周期：</span>
              <div>{{ formData.settleCycle || "-" }}</div>
            </el-col>
            <el-col :span="8" class="base-box mt-10">
              <span class="label">账单期数：</span>
              <el-popover placement="top-start" trigger="hover">
                <div style="max-width: 250px">
                  {{ formData.billCycleListStr || "-" }}
                </div>
                <div slot="reference" class="nowrap-ellipsis w240">
                  {{ formData.billCycleListStr || "-" }}
                </div>
              </el-popover>
            </el-col>
            <el-col :span="24" class="base-box">
              <el-col :span="8" class="base-box mt-10" v-if="isApproved">
                <span class="label">结算金额合计：</span>
                <div>
                  <span style="color: #ff5f1f">{{
                    formData.settleAmount | numFmt | numDigit
                  }}</span
                  >元
                </div>
              </el-col>
              <el-col :span="8" class="base-box mt-10">
                <span class="label">结算总额合计：</span>
                <div>
                  <span style="color: #ff5f1f">{{
                    settleTotalAmount | numFmt | numDigit
                  }}</span
                  >元
                </div>
              </el-col>
              <el-col :span="8" class="base-box mt-10" v-if="isApproved && comprehensiveScore">
                <span class="label">综合评分：</span>
                <div>
                  <span style="color: #ff5f1f">
                    {{ comprehensiveScore.toFixed(2) }}
                  </span>
                </div>
              </el-col>
            </el-col>
            <el-col
              v-if="formData.settleHedgeGuid"
              :span="24"
              class="base-box mt-10"
            >
              <span class="label" style="width: 140px">关联金额对冲流程：</span>
              <div class="file-img-box">
                <span>{{ formData.relevanceHedge || "-" }}</span>
                <a class="file-preview" @click="seeHedge(formData.filePath)"
                  >查看详情</a
                >
              </div>
            </el-col>
            <el-col :span="24" class="base-box mt-10">
              <span class="label">备注：</span>
              <div class="file-img-box">
                <span>{{ formData.memo ? formData.memo : "-" }}</span>
              </div>
            </el-col>
          </el-row>
          <img
            v-if="formData.isHedge == 'Y'"
            class="duichong-img"
            src="@/assets/images/ic_duichong.png"
            alt=""
            srcset=""
          />
          <img
            v-show="
              formData.approveVO && formData.approveVO.approveState !== 'N'
            "
            class="approve-img"
            :src="getApproveImg()"
            alt=""
          />
        </div>
        <!-- end of 对账单信息 -->

        <section v-for="(item, index) in formData.settleDetail" :key="index">
          <template v-if="formData.targetType === 1">
            <div
              class="back-color-fff mt-4"
              v-if="
                (item.taskType === '品牌推广' ||
                  item.taskType === '市场调研') &&
                item.taskType !== '数据采集' &&
                index === 0
              "
            >
              <el-row style="padding-top: 20px" :gutter="24">
                <el-col :span="24" class="base-box">
                  <span class="label">{{ reportName }}：</span>
                  <div class="file-img-box">
                    <span>{{ formData.relevance || "-" }}</span>
                    <a class="file-preview" @click="see(formData.filePath)"
                      >查看详情</a
                    >
                  </div>
                </el-col>
              </el-row>
            </div>
          </template>
          <!-- start of 对账单 -->
          <div class="back-color-fff mt-4 pb-16">
            <div class="form-title-box" id="title" style="width: 850px">
              <span class="form-title">{{ item.taskType }}对账单</span>
              <div>
                <el-button
                  type="info"
                  size="mini"
                  @click="billPrintClick(item, index)"
                  id="printBtn"
                  >打印{{ item.taskType }}对账单</el-button
                >
              </div>
            </div>
            <!-- 市场推广对账单 -->
            <div
              class="content-main-box detail-box"
              :id="'baseInfo' + index"
              style="overflow: hidden"
            >
              <h2 style="width: 800px">{{ item.taskType }}对账单</h2>
              <p>尊敬的客户:</p>
              <p>
                根据贵公司与我司所签订的服务协议，请贵公司确认以下费用明细，并进行相关款项支付，谢谢。
              </p>
              <p style="width: 800px" class="txt-right">
                对账日期：{{ formData.settleDate | getDate }}
              </p>

              <!-- 本期应付款总结算明细 -->
              <div class="table1" style="width: 800px" v-if="isApproved">
                <div class="header-div">本期应付款总结算明细</div>
                <div class="flex-between">
                  <div class="tab-label">本期应付款合计金额(小写)：</div>
                  <div class="tab-value" style="color: #ff5f1f">
                    ¥{{
                      item.totalAmount
                        | adjustFilter(item.mantissaAmount, [], approveState)
                        | numFmt
                        | numDigit
                    }}
                  </div>
                </div>
                <div class="flex-between">
                  <div class="tab-label">本期应付款合计金额(大写)：</div>
                  <div class="tab-value">
                    {{
                      item.totalAmount
                        | adjustFilter(item.mantissaAmount, [], approveState)
                        | smallToBig
                    }}
                  </div>
                </div>
              </div>

              <table
                class="table2"
                cellpadding="0"
                cellspacing="0"
                style="width: 800px; margin-top: 30px"
              >
                <thead>
                  <th style="width: 90px" class="t-center">序号</th>
                  <th style="width: 210px" class="t-center">任务类型</th>
                  <th style="width: 150px" class="t-center">数量</th>
                  <th style="width: 150px" class="t-center">单价</th>
                  <th style="width: 150px" class="t-center">单价单位</th>
                  <th style="width: 150px" class="t-center">备注</th>
                </thead>
                <tr v-for="(o, idx) in item.settleDetails" :key="idx">
                  <td class="t-center">{{ idx + 1 }}</td>
                  <td class="">{{ o.taskContent || "-" }}</td>
                  <td class="t-center">{{ o.qty || "-" }}</td>
                  <td class="t-center">{{ o.taskPrice || "-" }}</td>
                  <td class="t-center">
                    {{ o.taskPriceUnit || "-" }}
                  </td>
                  <td class="t-center">{{ o.remark || "-" }}</td>
                </tr>
              </table>

              <div class="info-box">
                <table class="table2" cellpadding="0" cellspacing="0">
                  <tr>
                    <th style="border-bottom: 0 none; width: 150px">
                      合计任务金额(元)：
                    </th>
                    <td
                      class="font-normal t-right"
                      style="border-top: 1px solid rgba(229, 229, 229, 1)"
                    >
                      {{ item.totalTaskAmount | numFmt | numDigit }}
                    </td>
                  </tr>

                  <tr v-if="isApproved">
                    <th>考核得分：</th>
                    <td class="font-normal t-right">
                      {{ item.assessmentScore || "-" }}
                    </td>
                  </tr>
                  <tr v-if="formData.isShowServiceFee == 'Y' && isApproved">
                    <th>服务费(元)：</th>
                    <td class="font-normal t-right">
                      {{ item.serviceAmount | numFmt | numDigit }}
                    </td>
                  </tr>
                  <tr v-if="isApproved">
                    <th>尾数调整(元)</th>
                    <td class="font-normal t-right">
                      <el-input-number
                        :disabled="approveState != 'N'"
                        :precision="2"
                        :controls="false"
                        placeholder="请输入"
                        v-model.trim="item.mantissaAmount"
                      >
                      </el-input-number>
                    </td>
                  </tr>
                  <tr v-if="isApproved">
                    <th>本期应付金额(元)：</th>
                    <td class="font-normal t-right">
                      {{ item.totalAmount | adjustFilter(item.mantissaAmount, [], approveState) | numFmt | numDigit }}
                    </td>
                  </tr>
                </table>
              </div>

              <div>
                <!-- start of 我方账户信息 -->
                <div class="info-box">
                  <p>支付账户信息如下：</p>
                  <table class="table2" cellpadding="0" cellspacing="0">
                    <tr>
                      <th style="border-bottom: 0 none; width: 80px">
                        开户名称：
                      </th>
                      <td
                        class="font-normal"
                        style="border-top: 1px solid rgba(229, 229, 229, 1)"
                      >
                        {{ formData.tenantContractBank?.tenantName || "-" }}
                      </td>
                    </tr>

                    <tr>
                      <th style="border-bottom: 0 none">开户银行：</th>
                      <td class="font-normal">
                        <el-select
                          style="width: 200px"
                          size="mini"
                          filterable
                          clearable
                          :disabled="approveState != 'N'"
                          v-model="formData.payBankInfoJson[index].bankAccount"
                          @change="(v) => bankReciveChange(v, item, index)"
                          placeholder="请选择开户银行"
                        >
                          <el-option
                            v-for="j in tenantContractBank.bankList"
                            :key="j.bankAccount"
                            :label="j.bankName"
                            :value="j.bankAccount"
                          >
                            <span>{{
                              `${j.bankName}_${j.bankAccount}_${$getNameByKey(
                                j.accountType,
                                "账户类型"
                              )}`
                            }}</span>
                          </el-option>
                        </el-select>
                      </td>
                    </tr>
                    <tr>
                      <th style="border-bottom: 0 none">银行账号：</th>
                      <td class="font-normal">
                        {{ formData.payBankInfoJson[index].bankAccount || "-" }}
                      </td>
                    </tr>
                  </table>
                </div>
                <!-- end of 我方账户信息 -->
              </div>

              <div class="flex-between" style="width: 800px">
                <div class="info-box">申请单位（盖章）：</div>
                <div class="info-box">审核单位（盖章）：</div>
              </div>
            </div>
          </div>
          <!-- end of 对账单 -->

          <template v-if="formData.targetType === 1">
            <div
              class="back-color-fff mt-4"
              v-if="
                item.taskType === '数据采集' &&
                (item.taskType !== '品牌推广' || item.taskType !== '市场调研')
              "
            >
              <el-row style="padding-top: 20px" :gutter="24">
                <el-col :span="24" class="base-box">
                  <span class="label">{{ reportName }}：</span>
                  <div class="file-img-box">
                    <span>{{ formData.relevance || "-" }}</span>
                    <a class="file-preview" @click="see(formData.filePath)"
                      >查看详情</a
                    >
                  </div>
                </el-col>
              </el-row>
            </div>
          </template>
        </section>

        <!-- start of 流程审批 -->
        <div class="back-color-fff mt-4 pb-16">
          <!-- <span class="form-title">流程审批</span> -->
          <div class="flow">
            <iframe
              scrolling="no"
              v-show="iframeSh"
              :src="iframeSrc"
              class="iframe-sty"
            ></iframe>
          </div>
        </div>
        <!-- end of 流程审批 -->
      </div>

      <!-- start of bottom-btn -->
      <div class="back-color-fff submit_btn_wrap">
        <el-button type="defalut" class="cannel-btn" size="mini" @click="goBack"
          >取消</el-button
        >
        <el-button
          type="danger"
          size="mini"
          v-show="getBtnState('approval') == 'approval'"
          @click="reject()"
          >驳回</el-button
        >
        <el-button
          type="primary"
          size="mini"
          v-show="getBtnState('approval') == 'approval'"
          @click="pass()"
          >通过</el-button
        >
        <el-button
          type="primary"
          size="small"
          v-show="getBtnState('revoke') == 'revoke'"
          @click="cancel()"
          >撤销</el-button
        >
        <el-button
          type="defalut"
          size="mini"
          v-show="approveState == 'N'"
          @click="submitForm(false)"
          >保存</el-button
        >
        <el-button
          type="primary"
          size="mini"
          v-show="approveState == 'N'"
          @click="submitForm(true)"
          >提交申请</el-button
        >
      </div>
      <!-- end of bottom-btn -->
    </div>
    <!-- end of form -->

    <!-- end of dialog-驳回 -->
    <el-dialog
      title="填写驳回备注"
      :visible.sync="rejectDialogVisible"
      width="30%"
      top="15%"
    >
      <el-input
        type="textarea"
        :rows="5"
        placeholder="输入驳回理由（必填）"
        v-model="approveSuggest"
        maxlength="100"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()"
          >驳回</el-button
        >
      </span>
    </el-dialog>
    <!-- end of dialog-驳回 -->

    <!-- 通过 -->
    <PassSettlementBillDialog
      ref="PassSettlementBillDialogRef"
      @submit="toPassSubmit"
    ></PassSettlementBillDialog>
    <!-- 通过 -->
    <printSettlementBill
      v-if="showPrint"
      :showPrintDialog.sync="showPrint"
      :printData="printData"
      :extradata="formData"
      :isApproved="isApproved"
      @closePrint="showPrint = false"
      :printType="printType"
    ></printSettlementBill>
  </div>
</template>

<script>
import printSettlementBill from "./components/printSettlementBill.vue";
import PassSettlementBillDialog from "./components/PassSettlementBillDialog.vue";
import { bpmnroute } from "@/api/apiRoute";
import { getAssignersIndex, computeScore, getScore, updateSecondAssignApproveState } from "@/api/msSalesPerformService";
import workFlowCommon from "@/uilt/workFlowCommon";
import { OrderTypeEnum } from "./enum";
export default {
  components: {
    printSettlementBill,
    PassSettlementBillDialog,
  },
  data() {
    return {
      that: this, //保存this以便filter中使用
      // mantissaAmount:0,
      printData: null,
      showPrint: false,
      guid: "",
      approveState: "",
      organisationName: "",
      formData: {
        relevance: "",
        settleDate: "",
        isStampApply: "",
        guid: "",
        filePath: "",
      },
      // 我方账号信息
      tenantContractBank: {},
      fullscreenLoading: false,

      // 流程图相关
      iframeSh: false,
      iframeSrc: "",

      rejectDialogVisible: false,
      approveSuggest: "",
      isFirstApprove: false, // 当前审批人是否是第一个
      isSecondApprove: false, // 当前审批人是否是第二个
      approveOrder: '', // 当前人在指定人节点上的位置索引 0/1/2
      isApproved: false, // 当前人在指定人节点上的位置索引为2时为true
      scoreTable: [
        { name: "根据数据质量评分（权重60%）", value: null },
        { name: "根据数据采集过程与效率评分（权重20%）", value: null },
        { name: "根据数据业务赋能评分（权重20%）", value: null },
      ],
      comprehensiveScore: null, // 综合评分
    };
  },
  async created() {
    this.guid = this.$route.query.guid;
    this.approveState = this.$route.query.approveState || "";
    const userinfo = JSON.parse(localStorage.userInfo);
    this.organisationName = userinfo.organisationName || "";
    await this.getDetailData();
    if (this.formData.settleHedgeGuid) {
      await this.getHedgeDetailData(this.formData.settleHedgeGuid); // 关联的金额对冲流程
    }
    await this.getInitApprovedState();
    await this.getScoreData();
    // 我方银行账号信息
    await this.getSettleReceiveBankList();
    this.getApprovalList();
  },
  watch: {},
  filters: {
    adjustFilter(value, amount, list, state) {
      let num = Number(value);
      if (state == "N") {
        //草稿中的状态才需要加尾数调整
        if (list && list.length > 0) {
          //对账单信息里的结算总额
          list.forEach((item) => {
            // let mantissaAmount=Math.floor(Number(item.mantissaAmount)  * 100) / 100
            let mantissaAmount = Number(item.mantissaAmount);
            if (mantissaAmount && !isNaN(item.mantissaAmount)) {
              num += mantissaAmount;
            }
          });
        } else {
          if (!isNaN(amount)) {
            // num=Number(value) + Math.floor(Number(amount)  * 100) / 100
            num = Number(value) + Number(amount);
          }
        }
      }
      return num;
    },
  },
  computed: {
    // 判断是否有质量考核报告 // !优先取质量考核报告, 如果没有则取运营报告
    checkReport() {
      let check = {
        reportGuid:
          this.formData.operationReportGuidList &&
          this.formData.operationReportGuidList[0]
            ? this.formData.operationReportGuidList[0]
            : "",
        isQualityApproval: this.formData.targetType === 2 ? true : false,
      };
      return check;
    },
    reportName() {
      return this.checkReport.isQualityApproval
        ? "关联质量考核"
        : "关联运营报告";
    },
    // 结算总额合计（草稿状态下累加尾数调整）
    settleTotalAmount() {
      let num = 0;
      this.formData?.settleDetail?.forEach((item) => {
        let itemAmount = Number(item.totalAmount);
        if (this.approveState == "N" && !isNaN(item.mantissaAmount)) {
          itemAmount += Number(item.mantissaAmount);
        }
        // 先按界面展示保留两位小数，再累加，避免最后汇总时四舍五入产生误差
        num += Number(itemAmount.toFixed(2));
      });
      return num;
    },
  },
  methods: {
    //返回列表
    goBack() {
      this.$router.push({
        path: "/downstreamSettlement",
      });
    },
    //状态图片
    getApproveImg() {
      return workFlowCommon.getApproveImg(
        this.formData.approveVO && this.formData.approveVO.approveState
      );
    },
    /**
     * 获取详情
     */
    async getDetailData() {
      let self = this;
      const { data } = await self.api.get(
        `/${serverConfig.msSalesPerformService}/downstream/statement/detail/${self.$route.query.guid}`
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      let statementParam = {};
      if (data.data.statementParamJson) {
        statementParam = JSON.parse(data.data.statementParamJson);
      }
      const billCycleListStr = statementParam.billCycleList?.join(",") || "";

      this.formData = {
        ...data.data,
        payBankInfoJson: data.data.payBankInfoJson
          ? JSON.parse(data.data.payBankInfoJson)
          : [],
        accountMonth: data.data.accountMonth
          ? JSON.parse(data.data.accountMonth)?.[0]
          : "-",
        billCycleListStr: billCycleListStr,
      };
      if (
        data.data.settleDetail?.length > this.formData.payBankInfoJson?.length
      ) {
        // 后端只返回一个payBankInfoJson，但settleDetail是多个，需要复制第一个值来匹配settleDetail的长度
        if (this.formData.payBankInfoJson.length > 0) {
          const firstBankInfo = this.formData.payBankInfoJson[0];
          while (
            this.formData.payBankInfoJson.length < data.data.settleDetail.length
          ) {
            this.formData.payBankInfoJson.push({ ...firstBankInfo });
          }
        }
      }

      let accountMonth = data.data.accountMonth
        ? JSON.parse(data.data.accountMonth)
        : [];
      // 显示发起人 + 药企简称 + 月份 + 应付金额
      this.formData["relevance"] = `${data.data["applyStaffName"]} _ ${
        data.data["operationReportTenantName"]
      } _ ${accountMonth.join(" , ")}${
        data.data["currentPayAmount"]
          ? " _ " + this.formatMoney(data.data["currentPayAmount"]) + "(元)"
          : ""
      }`;
    },
    async getHedgeDetailData(settleHedgeGuid) {
      const { data } = await this.api.get(
        `/${serverConfig.msSalesPerformService}/downstream/settle/hedge/detail/${settleHedgeGuid}`
      );

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }

      let paidAmount =
        data.data.paidAmount !== null
          ? `${this.formatMoney(data.data.paidAmount)}(元)`
          : "";
      let returnedAmount =
        data.data.returnedAmount !== null
          ? `${this.formatMoney(data.data.returnedAmount)}(元)`
          : "";
      // 显示发起人 + 药企简称 + 月份 + 应付金额
      this.formData["relevanceHedge"] =
        data.data["applyStaffName"] +
        " _ " +
        data.data["operationReportTenantName"] +
        (paidAmount ? " _ " + paidAmount : "") +
        (returnedAmount ? " _ " + returnedAmount : "");
    },
    // 我方银行账号信息
    async getSettleReceiveBankList() {
      const req = {
        tenantGuids: [localStorage.guid],
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get-banks`,
        req
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      if (!data.data?.length) {
        return;
      }
      this.tenantContractBank = {
        ...this.tenantContractBank,
        bankList: data.data[0]?.bankList || [],
      };
    },
    bankReciveChange(v, data, index) {
      const item = this.tenantContractBank.bankList.find(
        (item) => item.bankAccount == v
      );
      if (item) {
        this.formData.payBankInfoJson[index].bankName = item.bankName;
      }
    },
    /**
     * 获取操作按钮显隐
     * @param {*} btnType
     */
    getBtnState(btnType) {
      if (this.$route.query.approveVO) {
        let userinfo = JSON.parse(localStorage.userInfo);
        let approveVO = JSON.parse(this.$route.query.approveVO);
        return workFlowCommon.getListBtnState(
          btnType,
          approveVO.approveState,
          approveVO.staffGuid,
          approveVO.approveStaffGuids,
          userinfo.staffGuid,
          approveVO.approveState
        );
      }
    },
    /**
     * 关联流程，查看详情
     */
    see() {
      let approveVO = this.formData.approveVO ? this.formData.approveVO : {};
      let camundaInstanceId = approveVO.camundaInstanceId;
      let camundaDeploymentId = approveVO.camundaDeploymentId;
      if (this.checkReport.isQualityApproval) {
        this.seeQualityApproval(camundaInstanceId, camundaDeploymentId);
      } else {
        this.seeOperationReport(camundaInstanceId, camundaDeploymentId);
      }
    },
    // 查看质量考核
    seeQualityApproval(camundaInstanceId, camundaDeploymentId) {
      let query = {
        productGuid: this.$route.query.productGuid,
        guid: this.checkReport.reportGuid,
        isDownstream: true,
        //camundaInstanceId:camundaInstanceId,
        //camundaDeploymentId:camundaDeploymentId,
      };
      this.$router.push({
        path: "/qualityApprovalDetail",
        query,
      });
    },
    // 查看运营报告
    seeOperationReport(camundaInstanceId, camundaDeploymentId) {
      let query = {
        productGuid: this.$route.query.productGuid,
        guid: this.checkReport.reportGuid,
        camundaInstanceId: camundaInstanceId,
        camundaDeploymentId: camundaDeploymentId,
        toType: 2,
      };
      this.$router.push({
        path: "upstreamOperationReportDetail",
        query,
      });
    },
    /**
     * 关联流程，查看详情
     */
    seeHedge() {
      this.$router.push({
        path: "hedgeAmountDetail",
        query: {
          productGuid: this.$route.query.productGuid,
          guid: this.formData.settleHedgeGuid,
          toType: 2,
        },
      });
    },
    /**
     * 获取流程列表
     */
    getApprovalList() {
      // 00021:结算单流程,00022:付款单流程
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let { approveVO } = this.formData;
      if (
        this.guid &&
        approveVO.camundaInstanceId &&
        approveVO.camundaDeploymentId
      ) {
        this.iframeSrc =
          bpmnroute +
          "/iframeBpmn?processInstanceId=" +
          approveVO.camundaInstanceId +
          "&camundaDeploymentId=" +
          approveVO.camundaDeploymentId +
          "&token=" +
          localStorage.token;
        this.iframeSh = true;
        this.$forceUpdate();
        return;
      }
      let req = {
        tenantGuid: localStorage.guid,
        flowType: "00030",
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`,
          req
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSh = true;
              self.iframeSrc =
                bpmnroute +
                "/iframeBpmn?camundaDeploymentId=" +
                res.data.data +
                "&token=" +
                localStorage.token;
              console.log(self.iframeSrc);
              this.$forceUpdate();
            } else {
              self.$message.error("未获取到流程信息");
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 驳回
     */
    reject() {
      this.rejectDialogVisible = true;
      this.approveSuggest = "";
    },
    /**
     * 获取当前审批是第几个 发起指定人 0/1/2
     */
    async getInitApprovedState() {
      try {
        // 草稿状态需要展示这些隐藏的字段
        if (this.approveState == 'N') {
          this.isApproved = true;
          return;
        }
        let userInfo = JSON.parse(localStorage.userInfo);
        let { approveVO } = this.formData;
        if (!approveVO) return;
        const { data } = await getAssignersIndex({
          deploymentId: approveVO.camundaDeploymentId,
          processInstanceId: approveVO.camundaInstanceId,
          // staffGuid: userInfo.staffGuid,
        });
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message(data.msg)
          return 
        }
        this.approveOrder = data.data;
        this.isFirstApprove = this.approveOrder === '0';
        this.isSecondApprove = this.approveOrder === '1';
        this.isApproved = data.data === '2';
        if (this.formData.approveVO?.approveState == 'Y') {
          // 已通过展示
          this.isApproved = true
        }
        if (this.$route.query?.secondAssignApproveState == 'Y') {
          // 第二个指定人已通过展示
          this.isApproved = true
        }
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * 提交
     */
    async pass() {
      this.$refs.PassSettlementBillDialogRef.open({
        isFirstApprove: this.isFirstApprove,
        isSecondApprove: this.isSecondApprove,
        maxAmount: this.settleTotalAmount.toFixed(2),
        scoreTable: this.scoreTable,
        comprehensiveScore: this.comprehensiveScore,
      });
    },
    /**
     * 设置评分数据：scoreTable 值按后端返回保留（展示时四舍五入），
     * 综合评分 = 前面三项四舍五入之后的累加
     */
    setScores({ qualityGrade, processGrade, bizGrade } = {}) {
      const round = (v, digits = 2) => Number(Number(v || 0).toFixed(digits));
      this.scoreTable[0].value = round(qualityGrade, 6);
      this.scoreTable[1].value = round(processGrade, 6);
      this.scoreTable[2].value = round(bizGrade, 6);
      this.comprehensiveScore = round(
        this.scoreTable[0].value + this.scoreTable[1].value + this.scoreTable[2].value,
        2
      );
    },
    /**
     * 获取评分数据（进页面时加载，用于详情页综合评分展示）
     */
    async getScoreData() {
      try {
        const { data } = await getScore({ guid: this.formData.guid });
        if (data.code == serverConfig.REQUIRE_SUCCESS_CODE && data.data) {
          this.setScores(data.data);
        }
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * 撤销
     */
    cancel() {
      let self = this;
      let { approveVO } = this.formData;
      this.$confirm("撤销后,该流程将不再进行审核,确定这样操作吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let query = {
            guid: approveVO.approveGuid,
            flowType: approveVO.flowType,
            approveStaffGuid: approveVO.staffGuid,
          };
          self.fullscreenLoading = true;
          self.api
            .postJson(
              `/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`,
              query
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.fullscreenLoading = false;
                self.$message.success("撤销成功！");
                self.$router.go(-1);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    /**
     * 驳回提交
     */
    async toRejectSubmit() {
      if (!this.approveSuggest) {
        return this.$message.error("请填写驳回理由");
      }
      let userInfo = JSON.parse(localStorage.userInfo);
      let { approveVO } = this.formData;
      let query = {
        guid: approveVO.approveGuid,
        flowType: approveVO.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        return this.$message.error(data.msg);
      }
      this.rejectDialogVisible = false;
      this.approveSuggest = "";
      this.$message.success("驳回成功！");
      this.$router.go(-1);
    },
    /**
     * 第二个指定节点审批人点击"通过"后，修改下游对账单第二个节点审批状态
     * 失败时返回 false
     */
    async handleSecondAssignApproveState() {
      if (!this.isSecondApprove) {
        return true;
      }
      this.fullscreenLoading = true;
      const { data } = await updateSecondAssignApproveState([this.formData.guid]);
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return false;
      }
      return true;
    },
    /**
     * 通过提交
     */
    async toPassSubmit(payload = {}) {
      let userInfo = JSON.parse(localStorage.userInfo);
      let { approveVO } = this.formData;
      let query = {
        guid: approveVO.approveGuid,
        flowType: approveVO.flowType,
        approveSuggest: payload.approveSuggest || "",
        approveStaffGuid: userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      if (this.isFirstApprove) {
        const { data: scoreData } = await computeScore({
          guid: this.formData.guid,
          gradePayAmount : payload.approveAmount
        });
        this.fullscreenLoading = false;
        if (scoreData.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          return this.$message.error(scoreData.msg);
        }
      }
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`,
        query
      );
      this.fullscreenLoading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        return this.$message.error(data.msg);
      }
      const isSuccess = await this.handleSecondAssignApproveState();
      if (!isSuccess) return;
      this.$refs.PassSettlementBillDialogRef.close();
      this.$message.success("审批通过！");
      this.$router.go(-1);
    },
    /**
     * 提交
     */
    submitForm(flag) {
      this.adjustForm(flag);
    },
    async adjustForm(flag) {
      let self = this;
      let settleTypeDetail = JSON.parse(
        JSON.stringify(this.formData.settleDetail)
      );
      let query = {
        ...this.formData,
        settleGuid: this.formData.guid,
        immediateSubmit: flag,
        qualityAssessmentGuidList: this.formData.operationReportGuidList,
        settleDetail: [],
        settleTypeDetail: settleTypeDetail?.map(item => {
          return {
            ...item,
            mantissaAmount: item.mantissaAmount || 0,
          }
        }),
        payBankInfoJson: JSON.stringify(this.formData.payBankInfoJson),
      };
      if (!settleTypeDetail.length) {
        return;
      }
      let settleServiceAmountList = [];
      settleServiceAmountList = settleTypeDetail.map((item) => {
        return {
          taskTypeGuid: item.taskTypeGuid,
          mantissaAmount: item.mantissaAmount || 0,
        };
      });
      query.settleServiceAmountList = settleServiceAmountList;

      this.fullscreenLoading = true;
      const { data } = await self.api.postJson(
        `/${serverConfig.msSalesPerformService}/downstream/statement/update`,
        query
      );
      this.fullscreenLoading = false;

      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      if (flag) {
        self.$message.success("保存成功！");
      } else {
        self.$message.success("提交成功！");
      }
      this.$router.go(-1);
    },
    /**
     * 打印
     */
    billPrintClick(printData, index) {
      printData.curPayBankInfoJson = this.formData.payBankInfoJson[index];
      printData.serviceTenantContacts = this.formData.applyStaffName;
      printData.approveState = this.approveState;
      this.printData = printData;
      this.printType = 0;
      this.showPrint = true;
    },
    /**
     * 数字金额转大写
     * @param {*} num
     */
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split(".");

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 将整数部分和小数部分拼接起来
      return parts.join(".");
    },
  },
};
</script>

<style lang="less" scoped>
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
  word-break: keep-all;
}
.content {
  padding: 0px;
  margin: 0px;
  overflow-x: hidden;

  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;

    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(229, 229, 229, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }

    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .mt-4 {
    margin-top: 4px;
  }

  .pb-16 {
    padding-bottom: 16px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .mr-20f {
    margin-right: 20%;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .form-box {
    margin-top: 4px;
    text-align: left;

    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 18px;
      font-weight: 500;
      color: #323233;
    }

    /deep/ .el-row {
      margin-left: 20px !important;
      padding-bottom: 20px;
    }
    /deep/ .el-input-number.is-without-controls .el-input__inner {
      text-align: right;
    }
    .base-box {
      display: flex;
      align-items: center;

      .label {
        font-size: 14px;
        color: #666666;
        width: 100px;
        text-align: right;
      }
    }

    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;

      .el-button--primary {
        color: #ffffff;
      }
    }
  }

  .flex-between,
  .form-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .flex-between .info-box {
    height: 120px;
    padding-top: 5px;
    padding-left: 5px;
    // border: 1px solid #e5e5e5;
  }

  .form-title-box {
    padding-right: 16px;
  }

  h2 {
    text-align: center;
    margin-bottom: 0;
  }

  .txt-right {
    text-align: right;

    span {
      margin: 0px 16px;
    }
  }

  .table1 {
    .header-div {
      background: #f2f2f2;
      font-size: 14px;
      color: #333;
      letter-spacing: 0;
      font-weight: 500;
      text-align: center;
      font-weight: 700;
      height: 32px;
      line-height: 32px;
      border: 1px solid rgba(229, 229, 229, 1);
    }

    .tab-label {
      padding: 0px 10px;
      width: 280px;
      height: 32px;
      color: #212121;
      line-height: 32px;
      background: #fafafa;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      border-right: 1px solid rgba(229, 229, 229, 1);
      border-left: 1px solid rgba(229, 229, 229, 1);
    }

    .tab-value {
      text-align: right;
      padding: 0px 10px;
      width: calc(100% - 320px);
      height: 32px;
      line-height: 32px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      border-right: 1px solid rgba(229, 229, 229, 1);
      color: #666666;
    }

    p {
      color: #666666;
    }

    .line-box {
      // height: 40px;
      // line-height: 40px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);

      div:first-child {
        padding: 10px 10px;
        width: 70px;
        background: #fafafa;
        border-right: 1px solid rgba(229, 229, 229, 1);
      }

      div:last-child {
        padding: 10px 10px;
        width: calc(100% - 160px);
        // border-top: 1px solid rgba(229, 229, 229, 1);
      }
    }
  }

  .table2,
  .table3 {
    td {
      padding: 6px 5px;
      border: 1px solid rgba(229, 229, 229, 1);
      border-right: 0 none;
      border-top: 0 none;
    }

    th {
      border: 1px solid rgba(229, 229, 229, 1);
      border-right: 0 none;
      background: #f2f2f2;
      padding: 6px 5px;
    }

    td:last-child {
      border-right: 1px solid rgba(229, 229, 229, 1);
    }
  }

  .table2 {
    margin: 16px 0px;
    width: 100%;
  }

  .info-box {
    width: 390px;
    width: 100%;
    font-weight: bold;
  }

  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid rgba(229, 229, 229, 1);
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid rgba(229, 229, 229, 1);
  }

  .flow {
    background: #fff;
    padding-left: 20px;
  }

  .iframe-sty {
    width: 100%;
    border: none;
    height: 600px;
  }

  .detail-box {
    height: auto;
    border: 1px solid rgba(229, 229, 229, 1);
    margin: 0px 16px;
    padding: 0px 16px 100px 16px;
    width: 800px;
  }

  .table4 {
    padding: 0px;
  }

  .cannel-btn {
    border: 1px solid rgba(229, 229, 229, 1);
    border-radius: 2px;
    color: #212121;
  }

  .file-img-box {
    display: flex;
    align-items: center;

    img {
      width: 26px;
      height: 26px;
      margin-right: 10px;
    }

    .see-btn {
      font-size: 14px;
      color: #4fa1a4;
      letter-spacing: 0;
      line-height: 21px;
      font-weight: 400;
      cursor: pointer;
      margin-left: 10px;
    }
  }

  p {
    padding-bottom: 0px;
  }
}
.font-normal {
  font-weight: normal;
}
.total-tip {
  display: inline-block;
  margin-right: 10px;
}
.total-tip span {
  color: #ff5f1f;
}
.duichong-img {
  position: absolute;
  top: 0;
  right: 0;
  width: 81px;
}
.approve-img {
  position: absolute;
  top: 10%;
  right: 60px;
  width: 78px;
  height: 78px;
}
.adjust-input {
  /deep/ .el-input__inner {
    text-align: right;
  }
}
</style>
